import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useMontadoras } from '../../hooks/useMontadoras';
import { MontadoraInput } from '../../types/montadora';
import { Input } from '../../components/Input';
import { Button } from '../../components/Button';
import { ImageUpload } from '../../components/ImageUpload';

const MontadoraId: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { useMontadora, criarMontadora, atualizarMontadora, listLoading, getLogoUrl } = useMontadoras();
  const { data: montadora, isLoading: montadoraLoading } = useMontadora(id && id !== 'novo' ? id : '');
  
  const [formData, setFormData] = useState<MontadoraInput>({
    nome: '',
    logo: '',
  });
  const [logoFile, setLogoFile] = useState<File | null>(null);
  const [removerLogo, setRemoverLogo] = useState(false);

  useEffect(() => {
    if (montadora) {
      setFormData({
        nome: montadora.nome,
        logo: montadora.logo || '',
      });
    }
  }, [montadora]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!id || id === 'novo') {
      await criarMontadora({ 
        montadora: { nome: formData.nome }, 
        logoFile: logoFile || undefined 
      });
    } else {
      await atualizarMontadora({ 
        id, 
        montadora: { nome: formData.nome }, 
        logoFile: logoFile || undefined,
        removerLogo 
      });
    }

    navigate('/montadoras');
  };

  const handleLogoChange = (file: File | null) => {
    setLogoFile(file);
    setRemoverLogo(false);
  };

  const handleRemoveLogo = () => {
    setLogoFile(null);
    setRemoverLogo(true);
  };

  if (id !== 'novo' && montadoraLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  const currentLogoUrl = montadora?.logo ? getLogoUrl(montadora.logo) : null;

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <h1 className="text-2xl font-bold text-gray-800 mb-6">
        {!id || id === 'novo' ? 'Nova Montadora' : 'Editar Montadora'}
      </h1>

      <form onSubmit={handleSubmit} className="space-y-6">
        <div>
          <label className="block text-sm font-medium text-gray-700">Nome</label>
          <Input
            type="text"
            value={formData.nome}
            onChange={(e) => setFormData({ ...formData, nome: e.target.value })}
            required
          />
        </div>

        <div>
          <ImageUpload
            currentImage={removerLogo ? null : currentLogoUrl}
            onImageChange={handleLogoChange}
            onRemoveImage={handleRemoveLogo}
            label="Logo da Montadora"
            maxSize={2}
            disabled={listLoading || montadoraLoading}
          />
        </div>

        <div className="flex gap-4">
          <Button
            type="button"
            onClick={() => navigate('/montadoras')}
            className="bg-gray-500 hover:bg-gray-600"
          >
            Cancelar
          </Button>
          <Button type="submit" disabled={listLoading || montadoraLoading}>
            Salvar
          </Button>
        </div>
      </form>
    </div>
  );
};

export default MontadoraId; 